"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fromPromise = undefined;

var _PromiseObservable = require("./PromiseObservable");

var fromPromise = exports.fromPromise = _PromiseObservable.PromiseObservable.create;
//# sourceMappingURL=fromPromise.js.map


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/rxjs/static-5.3/observable/fromPromise.js
// module id = 224
// module chunks = 0